import { render, staticRenderFns } from "./MultipleCurrencyOptionButton.vue?vue&type=template&id=2cff1ae1&scoped=true&"
import script from "./MultipleCurrencyOptionButton.vue?vue&type=script&lang=js&"
export * from "./MultipleCurrencyOptionButton.vue?vue&type=script&lang=js&"
import style0 from "./MultipleCurrencyOptionButton.vue?vue&type=style&index=0&id=2cff1ae1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cff1ae1",
  null
  
)

export default component.exports